/**
 * @author vishwadeep.kapoor
 * MyEGiftCards constants
 *
 */

export const MY_E_GIFT_CONSTANTS = Object.freeze({
  DEFAULT_ACTION: '/MyEGiftCards/DEFAULT_ACTION',
  FETCH_GIFTCARD_SUCCESS: '/MyEGiftCards/FETCH_GIFTCARD_SUCCESS',
  SET_GIFTCARD_ACTIVATE_SUCCESS: '/MyEGiftCards/SET_GIFTCARD_ACTIVATE_SUCCESS',
  SET_OTP_GIFTCARD_SUCCESS: '/MyEGiftCards/SET_OTP_GIFTCARD_SUCCESS',
});

export const TEXT_NO_DATA_AVAILABLE = 'No e-Gift Cards to display';
export const DEFAULT_PRE_PAYLOAD = {
  page: 1,
  per_page: 12,
  secret_code: null,
  sent_to_others: false,
};

export const DEFAULT_PRE_PAYLOAD_O = {
  page: 1,
  per_page: 12,
  secret_code: null,
  sent_to_others: true,
};

export const LINK_ARRAY = [{
  index: 0,
  link: 'SENT_TO_ME',
  value: 'SENT TO ME',
  payload: DEFAULT_PRE_PAYLOAD,
},
{
  index: 1,
  link: 'SENT_TO_OTHERS',
  value: 'SENT TO OTHERS',
  payload: DEFAULT_PRE_PAYLOAD_O,
}];



// WEBPACK FOOTER //
// client/containers/MyEGiftCards/constants.js